// custom-service.js
function createCustomerService() {

  let qrcodeUrl = 'https://miaosu-1313118321.cos.ap-guangzhou.myqcloud.com/20251216-171911-yincong-wx-code.png'

  // 检查是否已经存在，避免重复添加
  if (document.getElementById('custom-service-container')) {
    return;
  }

  // 创建主容器
  const container = document.createElement('div');
  container.id = 'custom-service-container';

  // 添加浮窗图标和二维码
  const floatIcon = document.createElement('div');
  floatIcon.innerHTML = `
    <div class="custom-service-icon" style="
      position: fixed;
      width: 54px;
      height: 54px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 9999;
      border-radius: 25%;
      right: 20px;
      bottom: 60px;
      background: rgb(249, 84, 28);
    ">
      <div style="
        width: 54px;
        height: 54px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: linear-gradient(
          138deg,
          rgba(255, 255, 255, 0.45) 0%,
          rgba(255, 255, 255, 0) 100%
        );
        box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 12px 0px;
        border-radius: 12px;
      ">
        <div style="
          position: relative;
          width: 44px;
          height: 44px;
          z-index: 999999999;
          margin-right: 2px;
          margin-top: 4px;
          border-radius: 4px;
          background: url('https://miaosu-1313118321.cos.ap-guangzhou.myqcloud.com/20251216-182139-customer-service-icon.png')
            center center no-repeat;
          background-size: cover;
        "></div>
      </div>

      <!-- 二维码容器 - 默认隐藏 -->
      <div class="qr-container" style="
        display: none;
        position: absolute;
        right: 65px;
        bottom: 50%;
        transform: translateY(50%);
        z-index: 999999;
      ">
        <div style="
          position: absolute;
          right: -8px;
          top: 50%;
          transform: translateY(-50%);
          width: 0;
          height: 0;
          border-top: 8px solid transparent;
          border-bottom: 8px solid transparent;
          border-left: 8px solid rgb(38, 38, 38);
        "></div>

        <div style="
          min-width: 20px;
          height: 137px;
          line-height: 20px;
          font-size: 12px;
          color: rgb(255, 255, 255);
          text-align: center;
          background: rgb(38, 38, 38);
          border-radius: 4px;
          box-shadow: rgba(0, 0, 0, 0.1) -1px 2px 8px 0px,
            rgba(0, 0, 0, 0.06) 0px 2px 12px 0px;
          padding: 9px 9px 2px;
        ">
          <div style="
            width: 100px;
            height: 100px;
            margin-bottom: 4px;
            background: url(${qrcodeUrl})
              center center / 100% auto no-repeat;
          "></div>
          微信扫一扫
        </div>
      </div>
    </div>

    <div class="chat-bubble-container">
      <div class="chat-bubble" style="
        position: fixed;
        top: 50%;
        left: 50%;
        width: 324px;
        height: 158px;
        margin-left: -162px;
        margin-top: -79px;
        z-index: 1050;
        background: url('https://miaosu-1313118321.cos.ap-guangzhou.myqcloud.com/20251216-182139-customer-service-cover.png')
          no-repeat center center/100% 100%;
      ">
        <div class="info" style="
          width: 184px;
          height: auto;
          position: absolute;
          top: 0px;
          background: #ffffff;
          box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.15);
          color: #022eff;
          padding: 5px 5px 5px 10px;
          font-size: 14px;
          overflow: hidden;
          border-radius: 15px 15px 0px 15px;
        ">
          <div style="
            word-wrap: break-word;
            word-break: normal;
            max-height: 40px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          ">
            欢迎扫码咨询
          </div>
        </div>
      </div>
      <div class="close-btn" style="
        width: 18px;
        height: 18px;
        position: fixed;
        left: 50%;
        top: 50%;
        z-index: 9999;
        margin-left: 122px;
        margin-top: -60px;
        cursor: pointer;
        background: url('https://miaosu-1313118321.cos.ap-guangzhou.myqcloud.com/20251216-182139-customer-service-close-icon.png')
          center center / 100% 100% no-repeat;
      "></div>
      <div class="qr-code-bubble" style="
        width: 88px;
        line-height: 36px;
        text-align: center;
        height: 88px;
        color: rgb(255, 255, 255);
        cursor: pointer;
        position: fixed;
        top: 50%;
        left: 50%;
        border: 3px solid rgba(2, 46, 255, 0.3);
        margin-left: -138px;
        margin-top: -39px;
        z-index: 9999;
        background: url('https://miaosu-1313118321.cos.ap-guangzhou.myqcloud.com/20251216-171911-yincong-wx-code.png')
          center center / 100% 100% no-repeat;
        border-radius: 4px;
      "></div>
    </div>
  `;

  container.appendChild(floatIcon);
  document.body.appendChild(container);

  // 添加hover事件
  const iconElement = document.querySelector('.custom-service-icon');
  const qrElement = document.querySelector('.qr-container');

  if (iconElement && qrElement) {
    iconElement.addEventListener('mouseover', function () {
      qrElement.style.display = 'block';
    });

    iconElement.addEventListener('mouseout', function () {
      qrElement.style.display = 'none';
    });
  }

  // 添加关闭按钮事件
  const closeBtn = document.querySelector('.close-btn');
  const chatBubble = document.querySelector('.chat-bubble');
  const qrCodeBox = document.querySelector('.qr-code-bubble');

  if (closeBtn && chatBubble && qrCodeBox) {
    closeBtn.addEventListener('click', function () {
      chatBubble.style.display = 'none';
      qrCodeBox.style.display = 'none';
      closeBtn.style.display = 'none';
    });
  }

  // 添加二维码点击事件
  if (qrCodeBox) {
    qrCodeBox.addEventListener('click', function () {
      console.log('二维码被点击');
      // 可以在这里添加点击二维码的逻辑
    });
  }
}
// 主函数 - 创建客服组件并注入客服脚本
function showCustomerService() {
  // 创建客服组件
  createCustomerService();
}

// 导出函数供注入代码调用
window.createCustomerService = createCustomerService;
window.showCustomerService = showCustomerService;